import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { VendorsState } from "../../models/mp-common/vendors-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class AdminVendorsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.vendors.get),
			withLatestFrom(this.store.select(MpAdminSelectors.vendors)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.vendors.getSuccess(state))
					: of(MpAdminActions.vendors.getApi({ params: action.params }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.vendors.getApi),
			withLatestFrom(this.store.select(MpAdminSelectors.vendors)),
			switchMap(([action, state]) =>
				this.mpAdminService.vendors(action.params).pipe(
					map((vendors) =>
						MpAdminActions.vendors.getSuccess({
							vendors,
							allRetrieved: true,
							loading: false
						})
					),
					catchError((error) => of(MpAdminActions.vendors.getFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private mpAdminService: MpAdminService,
		private actions: Actions,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(action, state: VendorsState): boolean {
		const allQuery = this.noParams(action);
		const ids = _.split(_.get(action, "params.id", "noop"), ",");
		const storeIds = _.map(state.vendors, (v) => v.id);
		return !_.has(state, "error") && !state.loading && allQuery
			? state.allRetrieved
			: _.every(ids, (id) => _.includes(storeIds, id));
	}

	private noParams(action): boolean {
		return !action.params || _.keys(action.params).length === 0;
	}
}
